export enum DataHooks {
  ROOT = 'hidden-services-for-seo-root',
  LINK = 'hidden-services-for-seo-link',
}
